import React, { createRef } from 'react';
import GridMain from './GridMain';
import GridRoot from './GridRoot';
import GridPicker from './GridPicker';
import { configPrefer } from './gridcolalg';
import type { IGridItem, TItem } from './types';
import type { GridMainProps } from './GridMain';
import type { GridPickerProps } from './GridPicker';
import './index.less';

export type TDefaultPicker = TItem[];

export type TDefaultData = TItem[];
export interface GridBoardsProps
  extends Omit<GridMainProps, 'items'>,
    Omit<GridPickerProps, 'list' | 'cellSize' | 'pageSize' | 'mainRef'> {
  defaultData: TDefaultData;
  pickerList: TDefaultPicker;
  rootClassName?: string;
  onPickerChange?: (pi: TItem[]) => void;
}

export interface GridBoardsState {
  mainItems: TItem[];
}

class GridBoards extends React.Component<GridBoardsProps, GridBoardsState> {
  mainRef = createRef<GridMain>();

  pickerRef = createRef<GridPicker>();

  constructor(props: GridBoardsProps) {
    super(props);
    this.state = {
      mainItems: this.props.defaultData,
    };
    const { pickPostion } = this.props;
    // 优化重排方向
    if (pickPostion === 'bottom') {
      configPrefer('hor');
    } else {
      configPrefer('ver');
    }
  }

  insertItem = (item: TItem) => {
    return this.mainRef.current?.manualInsertItem(item);
  };

  removeItem = (item: TItem) => {
    return this.mainRef.current?.manualRemoveItem(item);
  };

  getEmptyPosition = (item: Omit<IGridItem, 'x' | 'y'>) => {
    return this.mainRef.current?.getEmptyPostion(item);
  };

  resetPickerPage = () => {
    return this.pickerRef.current?.setCurPage(0);
  };

  render() {
    const { mainItems } = this.state;
    const {
      col,
      row,
      width,
      height,
      onChange,
      onInsert,
      onRemove,
      onBeforeDrop,
      rootClassName = '',
      pickPostion = 'bottom',
      mainBg,
      pickerList,
      onBeforeRemove,
    } = this.props;

    const pickerCellSize = [width / col, height / row];

    const gridRootStyle =
      pickPostion === 'bottom'
        ? {
            width,
            height: height + 20 + pickerCellSize[1],
          }
        : {
            height,
            width: width + 20 + pickerCellSize[0],
          };

    const siderBound =
      pickPostion === 'bottom'
        ? { _SX_: col - 1, _SY_: null }
        : { _SY_: row - 1, _SX_: null };

    return (
      <div
        className={`grid-root grid-picker-${pickPostion} ${rootClassName} `}
        style={gridRootStyle}
      >
        <GridRoot {...siderBound}>
          {/* 注意 GridMain 是非受控的， GridPicker是受控的, GridMain 没有做成受控组件是个比较大的问题， 引其很多状态同步的问题 */}
          <GridMain
            ref={this.mainRef}
            col={col}
            row={row}
            width={width}
            height={height}
            items={mainItems}
            mainBg={mainBg}
            onChange={onChange}
            onBeforeRemove={onBeforeRemove}
            onRemove={(sec, item) => {
              if (sec && !item!.repeat) {
                this.props.onPickerChange?.([item, ...pickerList]);
                this.resetPickerPage();
              }
              onRemove?.(sec, item);
            }}
            onInsert={(sec, item) => {
              if (sec && !item?.repeat) {
                this.props.onPickerChange?.(
                  pickerList.filter((pi) => pi!.id !== item!.id),
                );
              }
              onInsert?.(sec, item);
            }}
            onBeforeDrop={onBeforeDrop}
          />
          <GridPicker
            ref={this.pickerRef}
            mainRef={this.mainRef}
            list={pickerList}
            cellSize={pickerCellSize as [number, number]}
            pageSize={pickPostion === 'bottom' ? col - 1 : row - 1}
            pickPostion={pickPostion}
          />
        </GridRoot>
      </div>
    );
  }
}

export default GridBoards;
